<template lang="pug">
.crud
  .container-fluid
    .title
      CardTitle(:text="$t('transfers.add_with_excel')" icon="archive-outline")
    vm-row(vm-align="center" vm-type="flex" vm-w="12")
      vm-col.direct-flex(vm-sm=12)
        div#spreadsheet.separator
        vm-col(vm-sm=2)
          vm-button(style="margin-left: 15px;" @click="cleanTab") {{ $t('strings.clear') }}
      vm-row(vm-sm="12")
        vm-col(vm-sm=12)
          vm-button.float-right(style="margin-top: 15px;" @click="saveDetail") {{ $t('strings.save') }}
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import jspreadsheet from 'jspreadsheet-ce'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Transfers')

export default {
  name: 'TabTransfers',
  components: {
    CardTitle: () => import('@/components/elements/CardTitle')
  },
  data: () => ({
    cleanData: [],
    customColumn: {
      closeEditor: function (cell, save) {
        var value = cell.children[0].value
        cell.innerHTML = value
        return value
      },
      openEditor: function (cell) {
        var element = document.createElement('input')
        element.value = cell.innerHTML
        cell.classList.add('editor')
        cell.innerHTML = ''
        element.focus()
      },
      getValue: function (cell) {
        return cell.innerHTML
      },
      setValue: function (cell, value) {
        cell.innerHTML = value
      }
    }
  }),
  mixins: [ViewMixinMaster1],
  computed: {
    ...mapGetters([
      'tabSheet',
      'validProduct',
      'transfer',
      'transferDetails',
      'convertedDetails',
      'invalidValue'
    ])
  },
  async created () {
    this.cleanSpreadSheet()
    await this.loadTransfer(this.$route.params)
  },
  methods: {
    ...mapActions([
      'convertToArrayOfObjects',
      'loadTransfer',
      'validateProduct',
      'cleanSpreadSheet',
      'sendAlertExcelWithoutProducts',
      'sendAlertInvalidData',
      'updateProducts'
    ]),
    removeEmptyValues () {
      this.cleanData = this.tabSheet.filter(function (item) { return item[0] !== '' && item[1] !== '' })
    },
    async saveDetail () {
      this.removeEmptyValues()
      await this.convertToArrayOfObjects(this.cleanData)
      if (!this.invalidValue) {
        if (this.cleanData.length) {
          const payload = { details: this.convertedDetails }
          this.validateProduct(payload).then(() => {
            const payload2 = { id: this.transfer.id, products: this.convertedDetails }
            if (this.tabSheet.length && this.validProduct) {
              this.updateProducts(payload2).then((status) => {
                if (status) this.goTransfers()
              })
            }
          })
        } else this.sendAlertExcelWithoutProducts()
      } else this.sendAlertInvalidData({ value: this.invalidValue })
    },
    onRenderSpread () {
      this.spread = jspreadsheet(document.getElementById('spreadsheet'), {
        data: this.tabSheet,
        minDimensions: [1, 1],
        allowInsertRow: true,
        allowManualInsertRow: false,
        allowInsertColumn: false,
        columns: [
          { title: 'Codigo', width: 200 },
          { title: 'Cantidad', width: 200 }
        ],
        filters: false,
        allowComments: true
      })
    },
    cleanTab () {
      this.cleanSpreadSheet()
      this.spread.destroy()
      this.onRenderSpread()
    },
    goTransfers () {
      this.$router.push(`/transfers`)
    }
  },
  async mounted () {
    this.onRenderSpread()
  }
}

</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.padding {
  padding: 3px 0px ;
}
</style>
